
import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { setAllowsBackGesture } from "@/utils/h5ToApp";

@Component({
  components: {},
})
export default class Workbench extends Vue {
  @Getter isMultiStore!: boolean;

  list: any[] = [
    {
      title: "营业分析",
      grid: [
        {
          label: "核心数据",
          src: require("@/assets/images/shouyin/workbench/CoreData.svg"),
          bgColor: "#F5F7FB",
          path: "/coreDataDetail",
        },
        {
          label: "类别占比",
          src: require("@/assets/images/shouyin/workbench/CategoryProportion.svg"),
          bgColor: "#F5FBF5",
          path: "/categoryProportionDetail",
        },
        {
          label: "付款方式",
          src: require("@/assets/images/shouyin/workbench/PaymentMethod.svg"),
          bgColor: "#F5FBFB",
          path: "/paymentMethodDetail",
        },
        {
          label: "商品排行",
          src: require("@/assets/images/shouyin/workbench/GoodsRanking.svg"),
          bgColor: "#FBF7F5",
          path: "/goodsRankingDetail",
        },
      ],
    },
  ];
  // 单店
  singleList: any[] = [
    {
      title: "收银查询",
      grid: [
        {
          label: "对账明细",
          src: require("@/assets/images/shouyin/workbench/CashReconciliation.svg"),
          bgColor: "#F5FBFB",
          path: "/reconciliationDetails",
        },
        {
          label: "交易明细",
          src: require("@/assets/images/shouyin/workbench/TransactionDetails.svg"),
          bgColor: "#F5F7FB",
          path: "/transactionDetail",
        },
      ],
    },
    {
      title: "会员查询",
      grid: [
        {
          label: "会员分析",
          src: require("@/assets/images/shouyin/workbench/MemberAnalysis.svg"),
          bgColor: "#FBF9F5",
          path: "/memberAnalysisDetail",
        },
        {
          label: "储值明细",
          src: require("@/assets/images/shouyin/workbench/StoredValueDetails.svg"),
          bgColor: "#FBF7F5",
          path: "/storedValueDetails",
        },
      ],
    },
    {
      title: "活动追踪",
      grid: [
        {
          label: "活动追踪",
          src: require("@/assets/images/shouyin/workbench/activity.svg"),
          bgColor: "#F5F7FB",
          path: "/activityDetail",
        },
      ],
    },
  ];
  // 多店
  multiList: any[] = [
    {
      title: "多店总览",
      grid: [
        {
          label: "多店核心数据",
          src: require("@/assets/images/shouyin/workbench/MultiCoreData.svg"),
          bgColor: "#F5FBF5",
          path: "/multiCoreDataDetail",
        },
      ],
    },
  ];

  onGridItemClick(item) {
    const { path } = item;
    path && this.$router.push(path);
  }
  created() {
    if (this.isMultiStore) {
      this.list = this.list.concat(this.multiList);
    } else {
      this.list = this.list.concat(this.singleList);
    }
  }

  // 是否禁用侧滑返回
  setAllowsBackGesture(isAllow: boolean) {
    setAllowsBackGesture(isAllow ? '1' : '0');
  }

  mounted() {
    this.setAllowsBackGesture(false);
  }
  beforeDestroy() {
    this.setAllowsBackGesture(true);
  }
}
